var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6668 1.99935C13.6668 1.26602 13.0668 0.666016 12.3335 0.666016H1.66683C0.933496 0.666016 0.333496 1.26602 0.333496 1.99935V9.99935C0.333496 10.7327 0.933496 11.3327 1.66683 11.3327H12.3335C13.0668 11.3327 13.6668 10.7327 13.6668 9.99935V1.99935ZM12.3335 1.99935L7.00016 5.33268L1.66683 1.99935H12.3335ZM12.3335 9.99935H1.66683V3.33268L7.00016 6.66602L12.3335 3.33268V9.99935Z",
    fill: "#89A00A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.2674215b5af07a35f5b3731b8f9bbc5f.svg";
export { ForwardRef as ReactComponent };